export const STATE_SUCCESS = "success";
export const STATE_ERROR = "error";
export const STATE_LOADING = "loading";
